<template>
    <!-- view file modal -->
    <div>
        <!-- when file can be view, like .doc or .ai, create a doownload link -->
        <a id="link" class="link" download hidden></a>
        <!-- dialog  -->
        <v-dialog v-model="dialog" max-width="750px" ref="modal" content-class="fileView" :fullscreen="fullscreen">
            <v-card>
                <v-card-title>
                    <h2>
                        <span>{{title}}</span>
                    </h2>
                    <v-spacer></v-spacer>
                    <!-- options on modal -- fullscreen & close  -->
                    <v-btn small icon @click="fullscreen = true" v-if="!fullscreen">
                        <v-icon>fullscreen</v-icon>
                    </v-btn>
                    <v-btn small icon @click="fullscreen = false" v-else>
                        <v-icon>fullscreen_exit</v-icon>
                    </v-btn>
                    <v-btn small icon @click="close()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <div class="content">
                    <!-- loader  -->
                    <div class="loader" v-if="loading">
                        <img src="../../assets/img/grid_loader.svg"/>
                    </div>
                    <!-- gallery ite & linked files on requests & comments -->
                    <div v-show="!loading" v-if="avatar == null">
                        <v-btn icon @click="back" v-if="this.gallery && this.gallery.length > 0"><v-icon>keyboard_arrow_left</v-icon></v-btn>
                        <!-- need a ifram to read pdf on a modal -- lie a lightbox for pdf file-->
                        <iframe class="frame" id="frame"></iframe>
                        <v-btn icon @click="next" v-if="this.gallery && this.gallery.length > 0"><v-icon>keyboard_arrow_right</v-icon></v-btn>
                    </div>
                    <!-- for avatar view -->
                    <div v-show="!loading" v-else class="img_container">
                        <img :src="avatar" v-if="avatar != null"/>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    components: { },
    data() {
        return {
            loading: false,
            dialog: false,
            gallery: [],
            title: '',
            fullscreen:false,
            avatar: null
        }
    },
    methods: {
        // when modal is open
        open(item,items) {
            // open the dialog of file can be viewed on a modal
            if(item.type == 'pdf' || item.type == 'jpg' || item.type == 'JPG' || item.type == 'jpeg' || item.type == 'png' || item.type == 'gif' || item.type == undefined) {
                this.dialog = true
            }
            // for avatar just fill the avatar data
            if(typeof items == 'string' && items == "avatar") {
                this.avatar = item
            } else {
                // else, load item & create galery whit files that can be viewed
                this.loadItem(item)
                if(items) {
                    this.gallery = items.filter(g => g.type == 'pdf' || g.type == 'jpeg' || item.type == 'jpg' || item.type == 'JPG' || g.type == 'png' || g.type == 'gif')
                } else {
                    this.gallery = item
                }
            }
        },
        next(){
            // when click on next arrow
            let active = document.querySelector('.frame').id
            let activeIndex = null
            this.gallery.forEach((i,index) => {
                if(i.id == active){
                    activeIndex = index
                }
            })
            if(this.gallery[activeIndex+1]) {
                this.loadItem(this.gallery[activeIndex+1])
            } else {
                this.loadItem(this.gallery[0])
            }
        },
        back() {
            // when click on back arrow
            let active = document.querySelector('.frame').id
            let activeIndex = null
            this.gallery.forEach((i,index) => {
                if(i.id == active){
                    activeIndex = index
                }
            })
            if(this.gallery[activeIndex-1]) {
                this.loadItem(this.gallery[activeIndex-1])
            } else {
                this.loadItem(this.gallery[this.gallery.length-1])
            }
        },
        loadItem(item){
            // loading items
            this.loading = true
            this.title = ''
            // if file can be viewed, just fill the iframe data
            if(item.type == 'pdf' || item.type == 'jpeg' || item.type == 'jpg' || item.type == 'JPG' || item.type == 'png' || item.type == 'gif') {
                // if galery given, with multiple item
                if(typeof item == 'object') {
                    document.querySelector('.frame').id = item.id
                    document.querySelector('.frame').src = item.path
                    this.title = item.label
                } else {
                    // if only one item given
                    document.querySelector('.frame').src = item
                }
                this.loading = false

            } else {
                // if file can't be viewed on lightbox, use the download link
                document.querySelector('#link').href = item.path
                document.querySelector('#link').download = item.label +'.'+ item.type
                document.querySelector('#link').click()
            }


        },
        close(){
            // when dialog is close, reset all
            this.dialog = false
            this.avatar = null
            this.fullscreen = false
            if(document.querySelector('.frame')) {
                document.querySelector('.frame').src = ''
            }
        }
    },
    created(){
        // create a bus, to open this viewer from anywhere
        this.$eventHub.$on('view-file',(item,items) => {
            this.open(item,items)
        })
    }
}
</script>

<style lang="stylus" scoped>
.fileView {
    div.content {
        display: flex
        align-items: center
        justify-content: center
        width: 100%
        height: 100%
        text-align: center
        .loader {
            margin-top:2rem
            margin-bottom:2rem
            display: flex
            align-items: center
            justify-content: center
        }
        div {
            width: 100%
            height: 100%
            .frame {
                border:none
                height: 100%
                width: 100%
            }
            .btn {
                position: absolute
                top: 50%
                &:last-of-type{
                    right:0
                }
            }
        }
    }
}
</style>
<style lang="stylus">
@require '../../../src/assets/css/variables'
.fileView {
    height:75rem
    &.dialog--fullscreen{
        height: 100%
    }
    .card {
        .card__title {
            h2{
                color: $text-color!important
            }
            .btn {
                .icon {
                    color: $text-color!important
                }
            }
        }
        display: flex
        flex-direction: column
        height: 100%!important
        overflow: hidden
    }
    .img_container {
        overflow: hidden
        display: flex
        align-items: center
        justify-content: center
        img {
            max-width: 100%
            max-height: 85%
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/files/ViewFiles.vue